/**
 * Ensure user is admin.
 */
const ensureAdmin = ({ req, res, locals, assert, load, flash }, next) => {
  // load the user from the database and ensure it exists and they are an admin
  return load("activeUser", { user: locals.user._id }).then((activeUser) => {
    if (activeUser && (activeUser.admin || activeUser.hasRole("admin")))
      return next();
    res.redirect("/404");
  });
};

export default ensureAdmin;
